var map = {
	"./amy-rare.jpeg": 9437,
	"./babystamp-rare.jpeg": 8848,
	"./bow-common.jpeg": 5789,
	"./boxy-rare.jpeg": 6219,
	"./carrots-rare.jpeg": 6937,
	"./catstamp-common.jpeg": 6658,
	"./charles-common.jpeg": 4678,
	"./hello-common.jpeg": 9629,
	"./magentaflower-rare.jpeg": 4970,
	"./melody-rare.jpeg": 6564,
	"./snowdrop-legendary.jpeg": 5648
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3122;